$(document).ready(function () {
 function TotalLength(el){

    var path = document.querySelectorAll(el);
    if($(el).length > 0){
      for (let elem of path) {
        if(elem.getAttribute("stroke-dasharray")){
          var len = Math.round(elem.getTotalLength() );
          elem.setAttribute("stroke-dasharray", len);
          elem.setAttribute("stroke-dashoffset", len);
          elem.classList.add('draw');
        }
      }
    }
  };
 var header_banner = $('.header-banner.with-animation');
  if(header_banner){
    header_banner.find('.z-top__header').css('opacity','1');
    TotalLength('#actuator-with-usp #Oval');
    TotalLength('#actuator-with-usp #Path');
    setTimeout(function() {
      header_banner.find('.z-top__text').css('opacity','1');
      header_banner.find('.header-content-icons-block svg').css('opacity','1');
      header_banner.find('.header-content-icons-block img').css('opacity','1');
      header_banner.find('#logo_actuators_landing').css('opacity','1');
      TotalLength('#actuator-icon-collection path');
      TotalLength('#actuator-icon-collection #Oval');
      TotalLength('#actuator-icon-collection #Path');
    }, 1000);
    setTimeout(function() {
      header_banner.find('.btn').css('opacity','1');
      header_banner.find('.swiper-container').css('opacity','1');
      header_banner.find('.brands-slide').css('opacity','1');
      TotalLength('#actuator-icon path');
      TotalLength('#actuator-icon #Oval');
      TotalLength('#product_icon #Path');
      TotalLength('#product_icon #Oval');
      header_banner.find('.header-content-icons-title').css('opacity','1');
      header_banner.find('.header-svg circle').css('opacity','1');
      header_banner.find('#actuator-with-usp .path-fill').addClass('full');
      header_banner.find('#actuator-with-usp .path-fill-dark').addClass('full');
    }, 2000);
    setTimeout(function() {
      header_banner.find('#actuator-icon .path-fill').addClass('full');
      header_banner.find('#product_icon .path-fill').addClass('full');
      header_banner.find('#product_icon .path-fill-dark').addClass('full');
      header_banner.find('#actuator-with-usp .path-fill-white').addClass('full');
    }, 2600);
  }

  const banner_svg =  $('.banner_without_images');
 
 if(banner_svg.length){
  
    banner_svg.find('.banner__heading').css('opacity','1');

   if($('#actuator-with-usp').length) {
    TotalLength('#actuator-with-usp #Oval');
    TotalLength('#actuator-with-usp #Path');
   }
  
    setTimeout(function() {
      banner_svg.find('.banner__text').css('opacity','1');
      banner_svg.find('.header-content-icons-block svg').css('opacity','1');
      banner_svg.find('.header-content-icons-block img').css('opacity','1');
      banner_svg.find('#logo_actuators_landing').css('opacity','1');
      if($('#actuator-icon-collection').length) {
      TotalLength('#actuator-icon-collection path');
      TotalLength('#actuator-icon-collection #Oval');
      TotalLength('#actuator-icon-collection #Path');
      }
    }, 1000);
    setTimeout(function() {
      banner_svg.find('.button').css('opacity','1');
      if($('#actuator-icon').length) {
      TotalLength('#actuator-icon path');
      TotalLength('#actuator-icon #Oval');
      }
        if($('#product_icon').length) {
      TotalLength('#product_icon #Path');
      TotalLength('#product_icon #Oval');
        }
      banner_svg.find('.header-content-icons-title').css('opacity','1');
      banner_svg.find('.header-svg circle').css('opacity','1');
      banner_svg.find('#actuator-with-usp .path-fill').addClass('full');
      banner_svg.find('#actuator-with-usp .path-fill-dark').addClass('full');
    }, 2000);
    setTimeout(function() {
      banner_svg.find('#actuator-icon .path-fill').addClass('full');
      banner_svg.find('#product_icon .path-fill').addClass('full');
      banner_svg.find('#product_icon .path-fill-dark').addClass('full');
      banner_svg.find('#actuator-with-usp .path-fill-white').addClass('full');
    }, 2600);
  }
    
});